import { render, staticRenderFns } from "./TodosScheduleAppointment.vue?vue&type=template&id=3bff8164"
import script from "./TodosScheduleAppointment.vue?vue&type=script&lang=js"
export * from "./TodosScheduleAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports